
export default {
    path: 'zbFile',
    component: () => import(/*webpackChunkName: 'bidding-kai-getoffer'*/ '@layout/empty'),
    children: [
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/form'),
            meta: {
                title: '上传招标文件',
            },
        },{
            path:"bysdetail",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/bys/bysdetail'),
            meta: {
                title: '补遗书详情',
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/detail'),
            meta: {
                title: '招标文件详情',
            },
        }
        
    ]
}